import React from 'react'

const Divider = ({}) => {
  return <div className='bg-brand-violet-semi_transparent_light h-[1px] w-full'></div>
}

export default Divider
